export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '1.26.3',
};
//# sourceMappingURL=buildEnv.js.map